import React from 'react';

export function Skeleton({
  width, height, radius, style,
}: { width?: number | string; height?: number | string; radius?: number | string; style?: React.CSSProperties }) {
  return (
    <div
      className="skeleton"
      style={{
        width: width ?? '100%',
        height: height ?? 12,
        borderRadius: radius,
        ...style,
      }}
    />
  );
}

export function SkeletonRow({ cols = 6 }: { cols?: number }) {
  return (
    <tr>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} style={{ padding: 'var(--sp-3) var(--sp-3)' }}>
          <Skeleton height={12} />
        </td>
      ))}
    </tr>
  );
}

export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div className="card" style={{ padding: 'var(--sp-5)' }}>
      <Skeleton height={16} width="40%" style={{ marginBottom: 'var(--sp-4)' }} />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={10} width={`${90 - i * 15}%`} style={{ marginBottom: 'var(--sp-2)' }} />
      ))}
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="card" style={{ padding: 'var(--sp-4)' }}>
      <Skeleton height={12} width="50%" style={{ marginBottom: 'var(--sp-3)' }} />
      <Skeleton height={28} width="40%" />
    </div>
  );
}
